import { AxiosError, AxiosResponse } from "axios";
import protheusProvider from "../providers/protheus.provider";

export class LoginService {
  public async auth(User: string, Password: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTLOGIN', {
        params: {
          User,
          Password
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}